import React from 'react';

//components
import Slider from 'react-slick';

//hooks
import { useChangeSlideValue } from '../../utils/hooks';

//styles
import styled from 'styled-components';
import flex from './../../styles/flex';
import { isHorizontal } from './../../styles/responsive';

//image
import OSR from './../../images/OSR-wBG.png';
import kChaiyo from './../../images/kChaiyo.jpg';
import Oxford from './../../images/OxfordSecurities.png';

function Clients() {
  //custom hooks
  const slides = useChangeSlideValue();

  const Content = styled.div({
    ...flex.centerVertical,
    ...flex.centerHorizontal,
    maxWidth: slides === 4 ? '1030px' : slides === 3 ? '800px' : slides === 2 ? '550px' : '250px',
    [isHorizontal]: {
      maxWidth: '250px'
    }
  });

  const clients = [
    { image: OSR, alt: 'OSR' },
    { image: Oxford, alt: 'Oxford Securities' },
    { image: kChaiyo, alt: 'kChaiyo' }
  ];

  var settings = {
    // dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(slides, clients.length),
    slidesToScroll: 1,
    adaptiveHeight: true
  };

  return (
    <Content>
      <center>
        <h2>Our Clients</h2>
      </center>
      <Slider {...settings}>
        {clients.map(client => (
          <div key={client.alt}>
            <img
              src={client.image}
              style={{
                width: '200px',
                margin: '30px',
                height: 'auto',
                borderRadius: '16px',
                overflow: 'hidden'
              }}
              alt={client.alt}
            />
          </div>
        ))}
      </Slider>
    </Content>
  );
}

export default Clients;
